import ChangePasswordPage from "../../../features/admin/change-password/change-password-page";

export default function ChangePassword() {
  return <ChangePasswordPage />;
}
